// SPORTS는 src/data/sports.js가 진실 소스입니다.
// 다른 컴포넌트의 import 경로를 바꾸지 않아도 되도록 여기서 재-export합니다.
export { SPORTS, sportCategory, isGrapplingSport, isStrikingSport, isCombatSport, isCardioSport, isStrengthSport, selectableSports, legacySportKey } from './sports';

export const MUSCLE_GROUPS = [
    '가슴', '상부가슴', '중부가슴', '하부가슴',
    '등', '광배근', '승모근', '능형근', '척추기립근',
    '어깨', '전면삼각근', '측면삼각근', '후면삼각근',
    '이두', '삼두', '전완근',
    '하체', '대퇴사두근', '햄스트링', '둔근', '내전근', '종아리',
    '복근', '상복부', '하복부', '복사근', '코어',
    '전신'
];

export const BJJ_POSITIONS = [
    '마운트', '백마운트', '풀가드', '하프가드', '버터플라이가드',
    '사이드컨트롤', '노스사우스', '터틀', '레그락', '스탠딩', '클린치', '기타'
];

export const SPARRING_PARTNER_LEVELS = ['화이트', '블루', '퍼플', '브라운', '블랙', '기타'];
export const GRAPPLING_PARTNER_LEVELS = ['입문/초급', '중급', '상급', '선수', '코치', '기타'];
export const STRIKING_PARTNER_LEVELS = ['입문/초급', '아마추어', '세미프로', '프로', '코치', '기타'];
export const MMA_PARTNER_LEVELS = ['입문/초급', '아마추어', '세미프로', '프로', '코치', '기타'];

export const STRIKING_CATEGORIES = ['펀치', '킥', '무릎/엘보', '방어', '클린치', '기타'];

export const STRIKING_DRILL_TYPES = ['줄넘기', '쉐도우복싱', '백(Heavy Bag)', '미트 트레이닝', '스파링', '기타'];

export const SOCIAL_PAGE_SIZE = 10;
export const FRIEND_PREFETCH_LIMIT = 12;
export const PROFILE_MIN_AGE = 14;
